"use client";
import { Icon } from "@/components/icon";
import classNames from "classnames";
import { AnimationEventHandler, useEffect, useRef } from "react";
import "./modal.css";
import { IModal } from "./modal.types";

export const Modal: IModal = ({ isVisible, hide, children }) => {
  const ref = useRef<HTMLDivElement>(null);

  const onAnimationEnd: AnimationEventHandler<HTMLDivElement> = (e) => {
    if (e.currentTarget.classList.contains("modal-hide")) {
      e.currentTarget.classList.add("modal-hidden");
    }
  };

  useEffect(() => {
    if (isVisible && ref.current) {
      ref.current.classList.remove("hidden");
    }
    if (isVisible) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [isVisible]);

  return (
    <div
      ref={ref}
      className={classNames(
        "modal flex-col items-center justify-center hidden",
        {
          flex: isVisible,
          "modal-visible": isVisible,
          "modal-hide": !isVisible,
        }
      )}
      onAnimationEnd={onAnimationEnd}
    >
      <div className="content w-full max-w-[641px] p-[60] relative flex flex-col items-center gap-[44px] bg-form-bg">
        <Icon
          onClick={hide}
          name="closeModal"
          className="absolute top-[20px] right-[20px] duration-200 ease cursor-pointer hover:scale-110 text-hover"
        />
        {children}
      </div>
    </div>
  );
};
